import { createRequestHelper } from '@utils/swr'
import { type CampaignUserVerificationsRequest } from '../types/apiRequest'
import { type CampaignUserVerificationsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['post']['campaignUserVerifications'], CampaignUserVerificationsResponse, CampaignUserVerificationsRequest>({
  client: 'fortune',
  key: params => `/campaigns/${params?.campaign_code}/member/campaign-user-verification`,
  fetcher: client => (_, params) => {
    return client.post(`/campaigns/${params?.campaign_code}/member/campaign-user-verification`, {
      cosign_token: params?.cosign_token,
      campaign_code: params?.campaign_code,
    })
  },
  isImmutable: true,
})

export const useApiCampaignUserVerification = useRequest
